import type { ReactNode } from 'react'

type Props = {
  leading?: ReactNode
  trailing?: ReactNode
  subtitle?: string
  children?: ReactNode
}

export default function PageHeader({ leading, trailing, subtitle, children }: Props) {
  return (
    <header
      className="bg-white shadow-sm border-t-[8px] border-transparent"
      style={{ borderImage: 'linear-gradient(to right, #00bcd4, #2196f3) 1' }}
    >
      <div className="mx-auto max-w-3xl px-4 py-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex-1 min-w-0 flex items-center">{leading}</div>
          <a href="/online_clinic" className="flex items-center gap-2 shrink-0">
            <img src="/assets/logo_house.svg" alt="おうち病院" className="h-7 w-7" />
            <img src="/assets/online_clinic/logo-title.png" alt="おうち病院" className="h-6 w-auto" />
          </a>
          <div className="flex-1 min-w-0 flex items-center justify-end">{trailing}</div>
        </div>
        {subtitle && <p className="mt-3 text-[14px] text-center text-[#7f8388]">{subtitle}</p>}
        {children}
      </div>
    </header>
  )
}
